import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api';

/**
 * Authenticated: request to join a group via its shortId invite link.
 * Idempotent on the server — a duplicate call while pending still returns
 * `{ ok: true, pending: true }`. A 409 ALREADY_MEMBER response means the
 * user is already in the group; the caller should refetch the preview so the
 * UI flips to `viewerState.kind === 'member'`.
 */
export function useRequestToJoin(shortId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      api.post<{ ok: true; pending: true }>(
        `/api/groups/by-short-id/${encodeURIComponent(shortId)}/join-request`,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: ['groups', 'by-short-id', shortId],
      });
    },
  });
}
